import axios from "axios";

export default {
  async getAnagrams(query: string) {
    const res = await axios.get("/api/anagram", {params: {query: query}});
    return res.data;
  }
}
